// Auth0's GenericError sets .error to a string code identifying the failure.
// We treat these all the same: redirect the user to log in interactively so
// the flow can re-establish a good session, rather than dead-ending callers.
//
// - `login_required` — no/expired session.
// - `interaction_required` — silent flow needs UI.
// - `consent_required` — can fire even for a first-party app when the callback
//   URI is non-verifiable (e.g. http://localhost): Auth0 forces the consent
//   screen there and a silent flow cannot satisfy it.
// - `missing_refresh_token` — useRefreshTokens is on but no refresh token is
//   cached (e.g. a session predating offline_access, or worker mode). The
//   iframe fallback normally recovers this, but if the fallback is disabled or
//   unavailable, an interactive login mints a refresh token cleanly.
//
// Other codes (`mfa_required`, etc.) are out of scope and are re-thrown by
// callers.
export function isReauthRequired(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }

  const code = (error as { error?: string }).error;

  return (
    code === 'login_required' ||
    code === 'interaction_required' ||
    code === 'consent_required' ||
    code === 'missing_refresh_token'
  );
}
